module.exports = __webpack_public_path__ + "img/2020-147_Stravenky-logoA-2025-12.93c641e3.png";